(function () {
  function checkRequiredFields(form, parentIsChecked) {
    // Get all the simple-card divs
    const simpleCards = Array.from(
      form.getElementsByClassName('simple-card')
    ).filter(card => !card.hasAttribute('hidden'));

    // Store the first simple-card div with an error
    let firstErrorCard = null;

    // Iterate over the simple-card divs
    for (let i = 0; i < simpleCards.length; i++) {
      const simpleCard = simpleCards[i];
      let requiredFields = [];

      if (parentIsChecked === 'parent') {
        requiredFields = Array.from(
          simpleCard.querySelectorAll('[required="true"]')
        ).filter(field => {
          const parent = field.closest('.has-selected-field');
          const hasSelectedField = parent.classList.contains('is-selected');
          const isSelected = hasSelectedField;
          return isSelected;
        });
      } else {
        requiredFields = simpleCard.querySelectorAll('[required="true"]');
      }

      // Check if any required field inside the simple-card is empty
      let hasError = false;
      for (let j = 0; j < requiredFields.length; j++) {
        const field = requiredFields[j];

        // Check if the field is hidden or empty
        let isHidden = false;
        if (field.hasAttribute('hidden')) {
          isHidden = true;
        }

        if (!isHidden && !field.value.trim()) {
          hasError = true;
          break;
        }
      }
    }

    // Scroll to the first simple-card div with an error, if any
    if (firstErrorCard) {
      firstErrorCard.scrollIntoView({ behavior: 'smooth' });
    }

    // Return true if there are no errors
    return !firstErrorCard;
  }

  let nextButton = document.querySelector('.js-next-btn');
  if (nextButton) {
    nextButton.addEventListener('click', function (event) {
      const form = document.getElementById('create-cap-form');
      const parentIsChecked = event.target.getAttribute('data-validation');
      if (form && !checkRequiredFields(form, parentIsChecked)) {
        event.preventDefault(); // Prevent form submission if required fields are not filled
      }
    });
  }
})();
